function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { components } from "react-select";
import { CardBody } from "reactstrap";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Chip from "@mui/material/Chip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import CommentsDisabledIcon from "@mui/icons-material/CommentsDisabled";
import SettingsVoiceIcon from "@mui/icons-material/SettingsVoice";
import MicIcon from "@mui/icons-material/Mic";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import Badge from "@mui/material/Badge";
import { debounce } from "lodash";
import moment from "moment";
import CircularProgressWithLogo from "../../../../components/mui/material/CircularProgressWithLogo";
import Button from "../../../../components/mui/material/Button";
import UserAvatar from "../../../../components/mui/material/UserAvatar";
import GroupAvatar from "../../../../components/mui/material/GroupAvatar";
import EmojiPopover from "../../../../components/mui/material/EmojiPopover";
// import MentionsInput from "components/react-mentions/MentionsInput";
import { useLanguagesContext } from "../../../../contexts/LanguagesContext";
import { useWebSocketContext } from "../../../../contexts/WebSocketContext";
import { useColumnVisibilityContext } from "../../contexts/ColumnVisibilityContext";
import { useCurrentGroupContext } from "../../contexts/CurrentGroupContext";
import { useShowCreateGroupContext } from "../../contexts/ShowCreateGroupContext";
import { useSubscriptionContext } from "../../../../contexts/SubscriptionContext";
import { streamingLanguageCodes, startRecording, stopRecording } from "../../../../components/aws/transcribeClient";
import { fetchMessagesByGroupId, fetchFirstWsMessageBySessionUserIdOrderByIdDesc, findFirstByMultiFalseAndMembers_User_IdInOrderByIdDesc, postGroup, postGroupMembers, pushWsMessage } from "../../../../actions";
import { stompCommands, roleIds, defaultPageSize, maxOneDayMessagesCount, subscriptionStateIds } from "../../../../constants";
import OptionsMenu from "./OptionsMenu";
import UserAsync from "./UsersAsync";
import MessageListItem from "./MessageListItem";
// import AttachmentsMenu from "./AttachmentsMenu";
import { Skeleton } from "@mui/material";
var tKey = "features.Chat.Messages";
var getPayloadSize = function getPayloadSize(value) {
  return Buffer.from(value).length;
};
function Messages(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLanguagesContext = useLanguagesContext(),
    languagePreferences = _useLanguagesContext.languagePreferences;
  var defaultLanguagePref = languagePreferences.find(function (pref) {
    return pref.appDefault;
  });
  var streamingLanguageCode = streamingLanguageCodes.find(function (lang) {
    return lang === defaultLanguagePref.language.code;
  });
  if (!streamingLanguageCode) streamingLanguageCode = streamingLanguageCodes.find(function (lang) {
    return lang.slice(0, 2) === defaultLanguagePref.language.code.slice(0, 2);
  });
  var _useSubscriptionConte = useSubscriptionContext(),
    toggleSubscriptionDialogOpen = _useSubscriptionConte.toggleSubscriptionDialogOpen;
  var _useWebSocketContext = useWebSocketContext(),
    wsClient = _useWebSocketContext.wsClient;
  var _useColumnVisibilityC = useColumnVisibilityContext(),
    showLeftColumn = _useColumnVisibilityC.showLeftColumn,
    showRightColumn = _useColumnVisibilityC.showRightColumn;
  var _useCurrentGroupConte = useCurrentGroupContext(),
    currentGroup = _useCurrentGroupConte.currentGroup,
    setCurrentGroup = _useCurrentGroupConte.setCurrentGroup;
  var _useShowCreateGroupCo = useShowCreateGroupContext(),
    showCreateGroup = _useShowCreateGroupCo.showCreateGroup,
    setShowCreateGroup = _useShowCreateGroupCo.setShowCreateGroup;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var authUserStats = useSelector(function (state) {
    return state.entities.userStats.byUserId[authUserId];
  });
  var authUserSubscription = useSelector(function (state) {
    return state.entities.subscriptions.byUserId[authUserId];
  });
  var authUserSubscribed = authUserSubscription && authUserSubscription.state.id === subscriptionStateIds.AUTHORIZED;
  var otherMember = currentGroup && !currentGroup.multi && currentGroup.members.find(function (member) {
    return member.user.id !== authUserId;
  });
  var messagesCall = useSelector(function (state) {
    return state.apiCalls.fetchMessagesByGroupId[currentGroup && currentGroup.id];
  }) || {};
  var messages = useSelector(function (state) {
    return state.entities.messages.byGroupId[currentGroup && currentGroup.id];
  });
  var typing = useSelector(function (state) {
    return state.entities.typings.byGroupId[currentGroup && currentGroup.id];
  });
  var wsMessageCall = useSelector(function (state) {
    return state.apiCalls.fetchFirstWsMessageBySessionUserIdOrderByIdDesc[otherMember && otherMember.user.id];
  }) || {};
  var wsMessage = useSelector(function (state) {
    return state.entities.wsMessages.firstBySessionUserIdOrderByIdDesc[otherMember && otherMember.user.id];
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    reachedEnd = _useState2[0],
    setReachedEnd = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    maxId = _useState4[0],
    setMaxId = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    users = _useState6[0],
    setUsers = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    optionsMenuAnchorEl = _useState8[0],
    setOptionsMenuAnchorEl = _useState8[1];
  // const [attachmentsMenuAnchorEl, setAttachmentsMenuAnchorEl] = useState(null);
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    emojiAnchorEl = _useState10[0],
    setEmojiAnchorEl = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showTyping = _useState12[0],
    setShowTyping = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    recording = _useState14[0],
    setRecording = _useState14[1];
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    setForceRender = _useState16[1];
  var _useState17 = useState(/*#__PURE__*/React.createRef()),
    _useState18 = _slicedToArray(_useState17, 1),
    scrollableRef = _useState18[0];
  var focusableItemRef = useRef(null);
  var skeletonDivRef = useRef(null);
  var messageTextRef = useRef(null);
  var optionsMenuOpen = Boolean(optionsMenuAnchorEl);
  // const attachmentsMenuOpen = Boolean(attachmentsMenuAnchorEl);
  var emojiOpen = Boolean(emojiAnchorEl);
  function toggleEmojiOpen(event) {
    if (emojiAnchorEl) {
      setEmojiAnchorEl(null);
    } else {
      setEmojiAnchorEl(event.currentTarget);
    }
  }
  var handleEmojiSelect = function handleEmojiSelect(emoji) {
    // const updatedText = (text || "") + emoji.native;
    // dispatch(change("text", updatedText));
    messageTextRef.current.value += emoji.native;
  };
  function handleMouseDown() {
    return _handleMouseDown.apply(this, arguments);
  }
  function _handleMouseDown() {
    _handleMouseDown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setRecording(true);
            startRecording(streamingLanguageCode, function (data) {
              if (!data || data.length === 0) return;
              messageTextRef.current.value += data;
              setForceRender(messageTextRef.current.value);
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleMouseDown.apply(this, arguments);
  }
  function handleMouseUp(event) {
    if (recording) {
      stopRecording();
      // handleSubmitMessage(event);
    }
    setRecording(false);
  }
  function handleKeyDown(event) {
    // Check if the pressed key is NOT a character
    if (event.key !== "Enter" && event.key.length !== 1 || event.ctrlKey || event.metaKey) return;
    if (!authUserSubscribed && authUserStats && authUserStats.oneDayMessagesCountChange > maxOneDayMessagesCount) {
      toggleSubscriptionDialogOpen(8);
      return;
    }
    if (!event.shiftKey && event.key === "Enter") {
      event.preventDefault();
      handleSubmitMessage(event);
      return;
    }
    if (!currentGroup) return;
    var typing = {
      groupId: currentGroup.id,
      userUsername: authUser.username,
      createdAt: moment.utc().toISOString()
    };
    wsClient && wsClient.send("/secured/typing", {}, JSON.stringify(typing));
  }
  function handleSubmitMessage(_x) {
    return _handleSubmitMessage.apply(this, arguments);
  }
  function _handleSubmitMessage() {
    _handleSubmitMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var message, group, postGroupAction, savedGroup, members, postGroupMembersAction, savedGroupMembers, _message;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            event.preventDefault();
            if (!(getPayloadSize(messageTextRef.current.value) > 8192)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            if (!currentGroup) {
              _context2.next = 8;
              break;
            }
            message = {
              userId: authUser.id,
              groupId: currentGroup.id,
              text: messageTextRef.current.value
            };
            wsClient && wsClient.send("/secured/message", {}, JSON.stringify(message));
            _context2.next = 22;
            break;
          case 8:
            group = {
              createdById: authUser.id,
              multi: users.length > 1
            };
            _context2.next = 11;
            return dispatch(postGroup(group));
          case 11:
            postGroupAction = _context2.sent;
            savedGroup = postGroupAction.response._embedded;
            members = users.map(function (user) {
              return {
                groupId: savedGroup.id,
                userId: user.id,
                createdById: authUser.id,
                roleIds: [roleIds.USER]
              };
            });
            _context2.next = 16;
            return dispatch(postGroupMembers(members));
          case 16:
            postGroupMembersAction = _context2.sent;
            savedGroupMembers = postGroupMembersAction.response._embedded;
            savedGroup.members = savedGroupMembers;
            _message = {
              userId: authUser.id,
              groupId: savedGroup.id,
              text: messageTextRef.current.value
            };
            wsClient && wsClient.send("/secured/message", {}, JSON.stringify(_message));
            setCurrentGroup(savedGroup);
          case 22:
            messageTextRef.current.value = "";
            setForceRender("");
            setShowCreateGroup(false);
            setUsers(undefined);
          case 26:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleSubmitMessage.apply(this, arguments);
  }
  function handleCloseClick(event) {
    event.preventDefault();
    setCurrentGroup(currentGroup);
    setShowCreateGroup(false);
    setUsers(undefined);
  }
  function handleFetchOld(maxId) {
    dispatch(fetchMessagesByGroupId(currentGroup.id, maxId, 100)).then(function (action) {
      return action.response && action.response.length < defaultPageSize && setReachedEnd(true);
    }).then(function () {
      focusableItemRef.current && focusableItemRef.current.scrollIntoView({
        behavior: "auto"
      });
    });
  }
  function handleScroll(event) {
    if (event.target.scrollTop === 0 && !reachedEnd) handleFetchOld();
  }
  useEffect(function () {
    if (!currentGroup) return;
    if (!showCreateGroup) setUsers(undefined);
    setMaxId(undefined);
    setReachedEnd(false);
    handleFetchOld(undefined);
  }, [currentGroup]);
  useEffect(function () {
    if (!otherMember || otherMember.user.type === "AiUser") return;
    dispatch(fetchFirstWsMessageBySessionUserIdOrderByIdDesc(otherMember.user.id));
    wsClient && wsClient.subscribe("/secured/user/queue/lastWsMessages-userId".concat(otherMember.user.id), function (res) {
      var data = JSON.parse(res.body);
      pushWsMessage(data, otherMember.user.id);
    });
  }, [otherMember]);
  var timeoutId;
  useEffect(function () {
    if (!typing || moment.utc().diff(moment.utc(typing.createdAt), "milliseconds") >= 2000) return;
    setShowTyping(true);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return setShowTyping(false);
    }, 2000);
  }, [typing]);
  useEffect(function () {
    if (!users) {
      return;
    } else if (users.length === 0) {
      setCurrentGroup(undefined);
      showLeftColumn();
      return;
    } else if (users.length > 1) {
      setCurrentGroup(undefined);
      return;
    }
    dispatch(findFirstByMultiFalseAndMembers_User_IdInOrderByIdDesc([authUser.id, users[0].id])).then(function (action) {
      return setCurrentGroup(action.response);
    });
  }, [authUser, users]);
  useEffect(function () {
    if (!scrollableRef || !scrollableRef.current) return;
    scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
  }, [messages]);
  useEffect(function () {
    if (!messages || messages.length === 0) return;
    setMaxId(messages[0].id - 1);
  }, [messages]);
  useEffect(function () {
    var debouncedHandleScroll = debounce(handleScroll, 100);
    window.addEventListener("scroll", debouncedHandleScroll);
    return function () {
      return window.removeEventListener("scroll", debouncedHandleScroll);
    };
  }, [messagesCall, maxId, reachedEnd]);
  var forwardProps = function (_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return rest;
  }(props);
  if (!showCreateGroup && !currentGroup) return /*#__PURE__*/React.createElement(Box, forwardProps, /*#__PURE__*/React.createElement(Box, {
    sx: {
      height: "100vh",
      // Adjust as needed
      display: "flex",
      flexDirection: "column",
      // If you want the icon above the text
      alignItems: "center",
      justifyContent: "center",
      gap: 1 // Space between icon and text
    }
  }, /*#__PURE__*/React.createElement(CommentsDisabledIcon, {
    fontSize: "large"
  }), /*#__PURE__*/React.createElement(Typography, {
    textAlign: "center"
  }, t("".concat(tKey, ".noGroupSelected")))));
  var ClearIndicator = function ClearIndicator(props) {
    return /*#__PURE__*/React.createElement(components.ClearIndicator, _extends({}, props, {
      innerProps: _objectSpread(_objectSpread({}, props.innerProps), {}, {
        onMouseDown: function onMouseDown(e) {
          e.stopPropagation();
          e.preventDefault();
        },
        onTouchEnd: function onTouchEnd(e) {
          e.stopPropagation();
          e.preventDefault();
        }
      })
    }), /*#__PURE__*/React.createElement(CloseIcon, {
      onMouseUp: handleCloseClick
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, forwardProps, showCreateGroup && /*#__PURE__*/React.createElement(UserAsync, {
    value: users,
    onChange: function onChange(option) {
      return setUsers(option);
    },
    isClearable: true,
    backspaceRemovesValue: true,
    components: {
      ClearIndicator: ClearIndicator
    }
  }), !showCreateGroup && currentGroup && /*#__PURE__*/React.createElement(AppBar, {
    sx: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement(Toolbar, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    "aria-label": "groups",
    onClick: showLeftColumn,
    sx: {
      display: {
        md: "none"
      }
    }
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    "aria-label": "avatar",
    disabled: true
  }, otherMember ? /*#__PURE__*/React.createElement(UserAvatar, {
    user: otherMember.user
  }) : /*#__PURE__*/React.createElement(GroupAvatar, {
    group: currentGroup
  })), /*#__PURE__*/React.createElement(Box, {
    onClick: showRightColumn,
    className: "cursor-pointer"
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
      overflowX: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: "200px" // Max width can be dynamic or flexible based on the container
    }
  }, currentGroup.name || currentGroup.members && currentGroup.members.filter(function (member) {
    return member.user.id !== authUser.id;
  }).map(function (member) {
    return member.user.fullName;
  }).join(",")), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: "1.43",
      letterSpacing: "0.01071em"
    }
  }, showTyping ? t("".concat(tKey, ".typing"), {
    username: typing.userUsername
  }) : !currentGroup.multi && otherMember.user.type === "AiUser" ? "Online" : wsMessageCall.isFetching ? /*#__PURE__*/React.createElement(Skeleton, {
    width: 150
  }) : wsMessage ? wsMessage.stompCommand === stompCommands.DISCONNECT ? t("".concat(tKey, ".lastSeen"), {
    lastSeen: moment(wsMessage.createdAt).calendar()
  }) : "Online" : !currentGroup.multi ? t("".concat(tKey, ".contactInfo")) : t("".concat(tKey, ".groupInfo"))))), /*#__PURE__*/React.createElement(Box, {
    edge: "end",
    sx: {
      display: "flex",
      alignItems: "center",
      gap: 1
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    edge: "end",
    "aria-label": "show options",
    "aria-controls": "chat-messages-options-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return setOptionsMenuAnchorEl(event.currentTarget);
    },
    color: "inherit"
  }, /*#__PURE__*/React.createElement(MoreVertIcon, null)), /*#__PURE__*/React.createElement(OptionsMenu, {
    id: "chat-messages-options-menu",
    open: optionsMenuOpen,
    anchorEl: optionsMenuAnchorEl,
    onClick: function onClick() {
      return setOptionsMenuAnchorEl(null);
    },
    onClose: function onClose() {
      return setOptionsMenuAnchorEl(null);
    }
  })))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    onScroll: function onScroll() {
      return debounce(handleScroll, 100);
    },
    ref: scrollableRef,
    sx: {
      position: "relative",
      height: "100%",
      width: "100%",
      overflow: "auto",
      scrollbarColor: "rgba(255, 255, 255, .16) transparent",
      scrollbarWidth: "thin"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto"
    }
  }), !messagesCall.isFetching && messages && messages.length > 0 && reachedEnd && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    sx: {
      marginTop: "10px",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t("".concat(tKey, ".joinedGroupOn"), {
      joinedAt: moment(messages[0].createdAt).format("L")
    }),
    sx: {
      p: 1,
      backgroundColor: function backgroundColor(theme) {
        return theme.palette.background.paper;
      }
    }
  })), !messagesCall.isFetching && messages && messages.length > 0 && !reachedEnd && /*#__PURE__*/React.createElement("div", {
    ref: skeletonDivRef
  }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "link",
    onClick: function onClick() {
      return handleFetchOld(maxId);
    }
  }, t("".concat(tKey, ".loadMore")))))), messagesCall.isFetching && /*#__PURE__*/React.createElement("div", {
    ref: skeletonDivRef
  }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(CircularProgressWithLogo, null)))), messages && messages.length > 0 && messages.map(function (message, i, array) {
    return message.id === -1 ? /*#__PURE__*/React.createElement("div", {
      key: i,
      ref: focusableItemRef,
      style: {
        clear: "both",
        hidden: true
      }
    }) : /*#__PURE__*/React.createElement(MessageListItem, {
      key: i,
      message: message
    });
  })), /*#__PURE__*/React.createElement(Paper, {
    component: "form",
    sx: {
      p: "2px 4px",
      display: "flex",
      alignItems: "center",
      borderRadius: 0
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "open drawer",
    onClick: toggleEmojiOpen,
    className: "d-md-down-none",
    sx: {
      p: "10px"
    }
  }, /*#__PURE__*/React.createElement(EmojiEmotionsIcon, null)), /*#__PURE__*/React.createElement(EmojiPopover, {
    open: emojiOpen,
    anchorEl: emojiAnchorEl,
    onClose: toggleEmojiOpen,
    handleEmojiSelect: handleEmojiSelect,
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "bottom",
      horizontal: "left"
    }
  }), /*#__PURE__*/React.createElement(Divider, {
    sx: {
      height: 28,
      m: 0.5
    },
    orientation: "vertical"
  }), /*#__PURE__*/React.createElement(InputBase, {
    multiline: true,
    inputRef: messageTextRef,
    onKeyDown: handleKeyDown,
    onChange: function onChange(event) {
      return setForceRender(event.target.value);
    },
    placeholder: t("".concat(tKey, ".writeMessage")),
    sx: {
      ml: 1,
      flex: 1,
      color: "inherit"
    }
  }), /*#__PURE__*/React.createElement(Divider, {
    sx: {
      height: 28,
      m: 0.5
    },
    orientation: "vertical"
  }), /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "send",
    onClick: function onClick() {
      return !authUserSubscribed && authUserStats && authUserStats.oneDayMessagesCountChange > maxOneDayMessagesCount ? toggleSubscriptionDialogOpen(8) : handleSubmitMessage();
    },
    disabled: !messageTextRef.current || !messageTextRef.current.value || messageTextRef.current.value === "",
    sx: {
      m: 0.5
    }
  }, /*#__PURE__*/React.createElement(SendIcon, null)), streamingLanguageCode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    sx: {
      height: 28,
      m: 0.5
    },
    orientation: "vertical"
  }), /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "record",
    sx: {
      m: 0.5
    },
    onMouseDown: function onMouseDown() {
      return !authUserSubscribed && authUserStats && authUserStats.oneDayMessagesCountChange > maxOneDayMessagesCount ? toggleSubscriptionDialogOpen(8) : handleMouseDown();
    },
    onMouseUp: handleMouseUp,
    onMouseLeave: handleMouseUp
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: streamingLanguageCode.slice(0, 2).toUpperCase(),
    sx: {
      ".MuiBadge-badge": {
        fontSize: "10px"
      }
    }
  }, recording ? /*#__PURE__*/React.createElement(SettingsVoiceIcon, null) : /*#__PURE__*/React.createElement(MicIcon, null)))))));
}
export default Messages;